import { motion } from "framer-motion";
import { useState, useRef } from "react";
import ConditionsModal from "@/components/CondicionesComerciales";

const EXPLORE = [
  { id: "top", label: "Inicio" },
  { id: "work", label: "Destinos" },
  { id: "studio", label: "Manifiesto" },
  { id: "services", label: "Disciplinas" },
  { id: "pricing", label: "Tarifas" },
  { id: "faq", label: "Preguntas frecuentes" },
  { id: "contact", label: "Contacto" },
];

function scrollTo(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(id === "top" ? 0 : el, { offset: -40, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export default function Footer() {
  const year = new Date().getFullYear();
  const [modalOpen, setModalOpen] = useState(false);
  const termsBtnRef = useRef(null);

  return (
    <footer
      id="site-footer"
      data-testid="site-footer"
      className="section-dark relative pt-20 lg:pt-24 pb-10 overflow-hidden"
    >
      {/* Top grid — three columns */}
      <div className="max-w-[95%] mx-auto grid grid-cols-12 gap-6 lg:gap-16">
        <div className="col-span-12 lg:col-span-5">
          <div className="font-sans text-[11px] tracking-[0.22em] uppercase opacity-60">
            La Michi Agencia · Barcelona
          </div>
          <p className="mt-6 font-sans text-base leading-relaxed opacity-80 max-w-sm">
            Estudio creativo de diseño web. Trabajamos con negocios que se toman en serio su manera de presentarse al mundo.
          </p>
        </div>

        <div className="col-span-6 lg:col-span-3">
          <div className="font-sans text-[11px] tracking-[0.22em] uppercase opacity-40 mb-4">Explorar</div>
          <ul className="space-y-2 font-sans text-sm">
            {EXPLORE.map((l) => (
              <li key={l.id}>
                <button onClick={() => scrollTo(l.id)} className="link-underline" data-testid={`footer-link-${l.id}`}>
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-12 lg:col-span-4">
          <div className="font-sans text-[11px] tracking-[0.22em] uppercase opacity-40 mb-4">Contacto</div>
          <a href="mailto:hello@lamichiagencia.com" className="font-display text-2xl lg:text-3xl link-underline">
            hello@lamichiagencia.com
          </a>
          <div className="mt-4 font-sans text-sm opacity-70">lamichiagencia.com</div>
        </div>
      </div>

      {/* Massive logotype block — huge faded background statement, fully visible */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 0.32, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1.4, ease: [0.76, 0, 0.24, 1] }}
        className="mt-20 lg:mt-28 text-center leading-[0.9] select-none px-4"
      >
        <div className="font-display text-[13vw] lg:text-[12vw] tightest">
          la michi{" "}
          <span className="font-italic-display" style={{ color: "#FF6B2C" }}>
            agencia.
          </span>
        </div>
      </motion.div>

      {/* Discreet inline link under the faded banner — opens the full modal */}
      <div className="relative mt-8 lg:mt-10 max-w-[95%] mx-auto text-center">
        <button
          ref={termsBtnRef}
          onClick={() => setModalOpen(true)}
          data-testid="footer-terms"
          aria-haspopup="dialog"
          className="group inline-flex items-center gap-2 font-sans text-sm lg:text-[15px] opacity-80 hover:opacity-100 transition-opacity"
          style={{ color: "#FAF8F5" }}
        >
          <span className="relative">
            Ver Condiciones Comerciales
            <span
              className="absolute left-0 right-0 -bottom-0.5 h-px bg-current opacity-40 group-hover:opacity-100 transition-opacity duration-500"
            />
          </span>
          <span
            className="transition-transform duration-500 group-hover:translate-x-1"
            aria-hidden="true"
          >
            →
          </span>
        </button>
      </div>

      {/* Bottom meta row */}
      <div className="max-w-[95%] mx-auto mt-10 lg:mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-3 font-sans text-[11px] tracking-[0.2em] uppercase opacity-60">
        <div>© {year} La Michi Agencia · Todos los derechos reservados</div>
        <div className="flex items-center gap-2">
          <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: "#FF6B2C" }} />
          Diseñado en Barcelona
        </div>
      </div>

      {/* Full Condiciones Comerciales modal */}
      <ConditionsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        triggerRef={termsBtnRef}
      />
    </footer>
  );
}
